import ApiService from "./api.service";

class ContactService extends ApiService {
    getPersonTwoFactor(personId) {
        return this.get(`api/management/group/people/${personId}/2fa`);
    }

    setPersonTwoFactorRequirement(personId, required) {
        return this.put(`api/management/group/people/${personId}/2fa/requirement`, { required });
    }

    resetPersonTwoFactor(personId, reason) {
        return this.post(`api/management/group/people/${personId}/2fa/reset`, { reason });
    }

    getPersonTwoFactorEvents(personId, page = 1, pageSize = 20) {
        return this.get(`api/management/group/people/${personId}/2fa/events`, { params: { page, pageSize } });
    }

    index(ses) {
        return this.get(`api/management/group/groups/${ses}`);
    }

    show(ses) {
        return this.get(`api/management/group/groups/${ses}`);
    }

    showUserData(id) {
        return this.get(`api/management/group/people/${id}`);
    }

    getUserQrCodeForLogin(id) {
        return this.get(`api/management/group/people/qr-code/${id}`);
    }

    showGroupData(id) {
        return this.get(`api/management/group/groups/${id}`);
    }

    checkContactExist(data) {
        return this.post("api/management/group/people/check-contact", data)
    }

    createContact(data) {
        return this.post("api/management/group/people", data);
    }

    createGroup(data) {
        return this.post("api/management/group/groups", data);
    }

    updateContact(id, data) {
        return this.post(`api/management/group/people/${id}`, data);
    }

    updateGroup(id, data) {
        return this.post(`api/management/group/groups/${id}`, data);
    }

    deleteGroup(id) {
        return this.delete(`api/management/group/groups/${id}`);
    }

    deleteContact(id) {
        return this.delete(`api/management/group/people/${id}`);
    }

    getUsersToSmsOrEmail(type) {
        return this.get(`api/management/announcement/sms/${type}`);
    }

    sendSMSToUsers(data) {
        return this.post(`api/management/sms/send`, data)
    }

    sendEmailToUsers(data) {
        return this.post(`api/management/email/send`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
    }

    getUserDataToEdit(id) {
        return this.get(`api/management/group/getUserDataToEdit/${id}`);
    }

    getPublicUserInfo(id) {
        return this.get(`api/management/group/getPublicUserInfo/${id}`)
    }

    addorupdatePublicUserInfo(id, data) {
        return this.post(`api/management/group/addorupdatePublicUserInfo/${id}`, data)
    }

    addOrEditUserPermissionData(uid, data) {
        return this.post(`api/management/group/addOrEditUserPermissionData/${uid}`, data)
    }

    addOrEditUserGroupsPermissionData(lid, data) {
        return this.post(`api/management/group/addOrEditUserGroupsPermissionData/${lid}`, data)
    }

    addOrEditUserLoginData(lid, data) {
        return this.post(`api/management/group/addOrEditUserLoginData/${lid}`, data)
    }

    prepareImageToSend(data) {
        return this.post(`api/management/group/prepareImageToSend`, data)
    }

    getResolutionBeginByYear() {
        return this.get(`api/management/group/getResolutionBeginByYear`)
    }

    setResolutionBeginByYear(data) {
        return this.post(`api/management/group/setResolutionBeginByYear`, data)
    }

    addMultiplePersons(data) {
        return this.post(`api/management/group/addMultiplePersons`, data)
    }

    getUsersLoginDataToWord() {
        return this.get(`api/management/group/getUsersLoginData/to-word`, { responseType: "arraybuffer" })
    }
    downloadUserCalendar(link){
        return this.get(link, { responseType: "arraybuffer" })
    }
    validatePerson(data){
        return this.post(`api/management/group/people/validate`, data)
    }
    getAdminsForGroupManage(groupId) {
        return this.get(`api/management/group/getAdminsForGroupManage/${groupId}`)
    }
    saveAdminsForGroupManage(groupId, data) {
        return this.post(`api/management/group/saveAdminsForGroupManage/${groupId}`, data)
    }
    getNfcPersonAssigment(){
        return this.get(`api/management/group/people/nfc-assigment`);
    }
    saveNfcPersonAssigment(id, data){
        return this.put(`api/management/group/people/${id}/nfc-assigment`, data);
    }
    deleteNfcPersonAssigment(id){
        return this.delete(`api/management/group/people/${id}/nfc-assigment`);
    }
    deletePeopleFromGroup(id, peopleIds){
        return this.delete(`api/management/group/groups/${id}/contacts`, peopleIds);
    }
    setUserPresence(id, data){
        return this.post(`api/management/group/people/${id}/presence-status-from-voting`, data);
    }
    searchContacts(criteria){
        return this.post(`api/management/group/groups/searcher/contact`, criteria);
    }

    getAvailablePrivileges(){
        return this.get(`api/management/group/groups/searcher/available-privileges`);
    }

    exportContacts(criteria){
        return this.post(`api/management/group/groups/searcher/export`, criteria, { responseType: "arraybuffer" });
    }

    getContactAttributeHistory(id, field){
        return this.get(`api/management/group/people/${id}/attribute-history`, { params: { field: field } });
    }

    addContactAttributeHistory(id, data){
        return this.post(`api/management/group/people/${id}/attribute-history`, data);
    }

    deleteContactAttributeHistory(id, historyId){
        return this.delete(`api/management/group/people/${id}/attribute-history/${historyId}`);
    }
}

export default new ContactService();
